import imageDeLaerhoeve from '../../../public/images/features/home/hero/nl/de-laerhoeve.jpg'
import imageGroenBeleven from '../../../public/images/features/home/hero/nl/groen-beleven.jpg'
import imageSparGlabbeek from '../../../public/images/features/home/hero/nl/spar-glabbeek.jpg'
import imageTreepower from '../../../public/images/features/home/hero/nl/treepower.jpg'
import imageZonnewind from '../../../public/images/features/home/hero/nl/zonnewind.jpg'
import imageBartMarijke from '../../../public/images/features/home/hero/fr/bart_marijke.jpg'
import imageChrisJeroen from '../../../public/images/features/home/hero/fr/chris_jeroen.jpg'
import imageRika from '../../../public/images/features/home/hero/fr/rika.jpg'
import imageStijn from '../../../public/images/features/home/hero/fr/stijn.jpg'
import imageYvan from '../../../public/images/features/home/hero/fr/yvan.jpg'

export const HERO_IMAGES = [
  {
    language: 'nl',
    fileName: 'de-laerhoeve.jpg',
    image: imageDeLaerhoeve
  },
  {
    language: 'nl',
    fileName: 'groen-beleven.jpg',
    image: imageGroenBeleven
  },
  {
    language: 'nl',
    fileName: 'spar-glabbeek.jpg',
    image: imageSparGlabbeek
  },
  {
    language: 'nl',
    fileName: 'treepower.jpg',
    image: imageTreepower
  },
  {
    language: 'nl',
    fileName: 'zonnewind.jpg',
    image: imageZonnewind
  },
  {
    language: 'fr',
    fileName: 'bart_marijke.jpg',
    image: imageBartMarijke
  },
  {
    language: 'fr',
    fileName: 'chris_jeroen.jpg',
    image: imageChrisJeroen
  },
  {
    language: 'fr',
    fileName: 'rika.jpg',
    image: imageRika
  },
  {
    language: 'fr',
    fileName: 'stijn.jpg',
    image: imageStijn
  },
  {
    language: 'fr',
    fileName: 'yvan.jpg',
    image: imageYvan
  }
]

export const HERO_IMAGES_NL = HERO_IMAGES.filter((heroImg) => heroImg.language === 'nl').map((heroImg) => heroImg.fileName)

export const HERO_IMAGES_FR = HERO_IMAGES.filter((heroImg) => heroImg.language === 'fr').map((heroImg) => heroImg.fileName)
